import { motion } from "framer-motion";

export default function AnimatedTitle({ title }) {
    return (
        <motion.h1
            initial={{ opacity: 0, y: 8, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{
                duration: 0.55,
                ease: [0.22, 1, 0.36, 1],
            }}
            className="
                text-[18px] sm:text-[20px]
                font-bold tracking-tight leading-tight
                text-gray-900 dark:text-white
                whitespace-nowrap
                min-w-0
            "
        >
            <span className="inline-grid">
                {/* Invisible text reserves the required width */}
                <span
                    className="invisible col-start-1 row-start-1"
                    aria-hidden="true"
                >
                    {title}
                </span>

                {/* Animated text */}
                <motion.span
                    className="col-start-1 row-start-1 overflow-hidden whitespace-nowrap"
                    initial={{ width: "0ch" }}
                    animate={{
                        width: [
                            "0ch",
                            `${title.length}ch`,
                            `${title.length}ch`,
                            "0ch",
                        ],
                    }}
                    transition={{
                        duration: 4.8,
                        times: [0, 0.22, 0.9, 1],
                        ease: ["linear", "linear", "easeInOut"],
                        repeat: Infinity,
                    }}
                >
                    {title}
                </motion.span>
            </span>
        </motion.h1>
    );
}